import { LazoView, useLazoView } from "@/contexts/CurrentLazoViewContext";
import { Colors } from "@/enums/Colors";
import { LazoPaths } from "@/enums/LazoPaths";
import { useResponsive } from "@/hooks/useResponsive";
import { ToggleButton, ToggleButtonGroup, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  height: "1.625rem",
  borderRadius: "0.375rem",
  padding: "0.125rem",
  backgroundColor: `${Colors.DARK_GREY_3E3E3E}`,
  "& .MuiButtonBase-root": {
    "&.MuiToggleButton-root": {
      ":hover": {
        filter: "brightness(110%)",
      },
      transition: "background-color 0.3s ease; color 0.3s ease",
      textTransform: "none",
      fontSize: "0.625rem",
      border: "none",
      color: `${Colors.LIGHT_GRAY_BFC2C6}`,
      fontWeight: "500",
      paddingLeft: "0.625rem",
      paddingRight: "0.625rem",
      whiteSpace: "nowrap",
      "&.Mui-selected": {
        borderRadius: "0.375rem",
        backgroundColor: "white",
        color: "black",
        "&:hover": {
          filter: "brightness(110%)",
        },
      },
    },
  },
});

export default function LazoPortalAndOneToggle() {
  const { t } = useTranslation("navigation");
  const { lazoView } = useLazoView();
  const { isDesktop } = useResponsive();

  return (
    <>
      <StyledToggleButtonGroup
        exclusive
        value={lazoView}
        sx={{
          marginBottom: isDesktop ? "1.5rem" : 0,
        }}
      >
        <ToggleButton disableRipple value={LazoView["LAZO_ONE"]} component={NavLink} to={LazoPaths.TASKS}>
          {t("footer.lazoOne")}
        </ToggleButton>
        <ToggleButton disableRipple value={LazoView["LAZO_PORTAL"]} component={NavLink} to={LazoPaths.TASKS_ADMIN}>
          {t("footer.lazoPortal")}
        </ToggleButton>
      </StyledToggleButtonGroup>
    </>
  );
}
